import { jsx as t } from "react/jsx-runtime";
import { createLocaleProvider as i, defaultNS as a } from "@systemeio/util";
import { isLocalizedCountriesRegistered as c, registerLocalizedCountries as n } from "../enums/countries/utilize-localized-countries.mjs";
const { LocaleContext: s, LocaleProvider: l } = i(), m = (e) => {
  var r;
  const o = (r = e.i18n) == null ? void 0 : r.getResource(e.languageCode, a, "countries");
  return o && !c(e.languageCode) && n({
    locale: e.languageCode,
    countries: o
  }), /* @__PURE__ */ t(l, { ...e });
};
export {
  s as LocaleContext,
  m as LocaleProvider
};
